import React, { useMemo, useState } from 'react';
import EditorialVideo from './EditorialVideo';
import ModalDialog from '../modal/ModalDialog';
const EditorialVideoContainer = (props) => {
    const [fullScreen, setFullScreen] = useState(false);
    const [defaultParams, setDefaultParams] = useState({});
    const [isBackFromOverlay, setIsBackFromOverlay] = useState(false);
    const [overlayParams, setOverlayParams] = useState({});
    const containerProps = useMemo(() => {
        return Object.assign(Object.assign({}, props), { isFullbleed: props.dimension === 'FULL_BLEED', fullScreen,
            setFullScreen,
            isBackFromOverlay,
            setIsBackFromOverlay });
    }, [props.dimension, fullScreen, isBackFromOverlay]);
    return (React.createElement(React.Fragment, null,
        React.createElement(EditorialVideo, Object.assign({}, props, containerProps, { onUpdate: setDefaultParams, overrideParams: overlayParams, forceActiveState: props.forceActiveState })),
        React.createElement(ModalDialog, { isOpen: fullScreen, onRequestClose: () => {
                setIsBackFromOverlay(true);
                setFullScreen(false);
            }, className: "editorial-video-modal", fullHeight: true, fullWidth: true, noSkin: true, hideCloseButton: true, buttonInHeader: false },
            React.createElement(EditorialVideo, Object.assign({ isFullscreenOverlay: true }, props, containerProps, { uuid: props.uuid + '-fullscreen', onUpdate: setOverlayParams, overrideParams: defaultParams })))));
};
export default EditorialVideoContainer;
